import { render, staticRenderFns } from "./top-langSelect.vue?vue&type=template&id=19c04e24&scoped=true"
import script from "./top-langSelect.vue?vue&type=script&lang=js"
export * from "./top-langSelect.vue?vue&type=script&lang=js"
import style0 from "./top-langSelect.vue?vue&type=style&index=0&id=19c04e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c04e24",
  null
  
)

export default component.exports